import * as React from 'react'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'
import * as model from '@owl-nest/models'
import { t } from '@owl-nest/localize'

import { type Project } from '../../../../models/project'
import { type Fan } from '../../../../models/fan'

type FollowerPropTypes = {
  follower: Fan
  project: Project
}

export function Follower({ follower }: FollowerPropTypes): React.ReactElement<FollowerPropTypes> {
  const tag = model.user.tag(follower, follower.role)

  return (
    <FollowerContainer>
      <plume.UserLabel
        avatar={model.user.avatar(follower, '40x40')}
        avatarSize="small"
        isPublic={follower.is_public}
        href={follower.is_public ? follower.absolute_url : ''}
        name={<plume.styles.heading.XXXS>{model.user.fullName(follower)}</plume.styles.heading.XXXS>}
        tag={tag}
      />
    </FollowerContainer>
  )
}

const FollowerContainer = styled.div`
  display: flex;
  padding: 7px;
  align-items: center;
  align-content: center;
  background-color: ${plume.COLORS.PRIMARY_GREY_000};
`
